// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://ararizm-003-site9.qtempurl.com';

// Firebase Configuration
export const FIREBASE_CONFIG = {
  enabled: process.env.REACT_APP_FIREBASE_ENABLED !== 'false', // Enable by default
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Game Configuration
export const GAME_CONFIG = {
  AUTO_SAVE: true,
  SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes
  MAX_RETRIES: 3,
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  GAME_SESSION: 'gameSession',
  GAME_SETTINGS: 'gameSettings',
};

// Game Types
export const GAME_TYPES = {
  NUMBER_SEQUENCE: 'NumberSequence',
  MEMORY_PALACE: 'MemoryPalace',
  TONE_MEMORY: 'ToneMemory',
  IMAGE_MATCHING: 'ImageMatching',
  TICKER_TAPE: 'TickerTape',
} as const;

export type GameType = typeof GAME_TYPES[keyof typeof GAME_TYPES];

// Game Type Mappings
export const GAME_TYPE_DISPLAY_NAMES = {
  [GAME_TYPES.NUMBER_SEQUENCE]: 'Number Sequencing',
  [GAME_TYPES.MEMORY_PALACE]: 'Memory Palace',
  [GAME_TYPES.TONE_MEMORY]: 'Tone Memory',
  [GAME_TYPES.IMAGE_MATCHING]: 'Image Matching',
  [GAME_TYPES.TICKER_TAPE]: 'Ticker Tape Rush',
} as const;